import React, { useState } from "react";
import { Button, Tooltip, Popconfirm } from "antd";
import {
  LogoutOutlined,
  UserOutlined,
  SyncOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { signOut, getUser } from "../../../utils/helpers";

import "./SidebarFooter.css";

export default function SidebarFooter() {
  const [showUpdate, setShowUpdate] = useState(false);

  const handleSignOut = () => {
    signOut();
  };

  const handleUpdate = () => {
    setShowUpdate(false);
  };

  const user = getUser();

  return (
    <div className="SideBarFooter">
      {showUpdate
        ? (
          <Button
            type="dashed"
            danger
            icon={<SyncOutlined />}
            onClick={handleUpdate}
            className="SideBarFooter__Update"
          >
            Update
          </Button>
        )
        : (
          <Tooltip placement="topLeft" title={user.email}>
            <div className="SideBarFooter__User ">
              <div className="SideBarFooter__User__Avatar">
                <UserOutlined />
              </div>
              <span>{`${user.first_name}`}</span>
            </div>
          </Tooltip>
        )}

      {user.id !== -1 && (
        <div className="Sidebar__Popconfirm">
          <Popconfirm
            title="Are you sure you want to Sign Out?"
            onConfirm={handleSignOut}
            placement="topLeft"
            okText="Yes"
            cancelText="No"
            icon={<LogoutOutlined />}
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <Button
              className="SideBarFooter__Logout"
              type="default"
              icon={<LogoutOutlined />}
            >
              Sign out
            </Button>
          </Popconfirm>
        </div>
      )}
      {user.id === -1 && (
      <Button
        className="SideBarFooter__Logout"
        type="default"
        icon={<LoginOutlined />}
        onClick={() => handleSignOut()}
      >
        Sign In
      </Button>
      )}
    </div>
  );
}
